module.exports = __webpack_public_path__ + "img/ic_file_downloaded.b0f5f283.svg";